module.exports = __webpack_public_path__ + "static/media/Speaker.ec336c32.png";